export const ROUTES = {
  login: "/login",
  unauthorized: "/no-autorizado",
  menu: "/menu",
  selectProperty: "/editar-propiedad",
  setupNew: "/setup/nueva",
  setupEdit: (documentId: string) => `/setup/editar/${documentId}`,
} as const;

export function isSetupEditPath(pathname: string): boolean {
  return pathname.startsWith("/setup/editar/");
}
